import React, { ReactElement, useCallback, useEffect, useRef, useState } from 'react'
import styles from './OauthAdd.module.scss'
import { reg, urlRegExpression } from 'core/utils/constants'
import { Translate } from 'react-localize-redux'
import { translate } from 'shared/helpers/utils'
import { connect } from 'react-redux'
import { addIntegration, addOauthClient } from '../Settings.actions'
import { OauthAddType } from './OauthAdd.types'
import { fetchAllOauthClients } from '../../tenants/create-account-signing-client/AccountSigningClient.actions'
import { Button, ButtonType, FormFieldSize, Input, MultiCopy, SubmitButton, Form } from '@digicert/dcone-common-ui'
import { faPlusCircle, faTrashAlt } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import history from 'core/history/history'
import {IconProp} from "@fortawesome/fontawesome-svg-core";

const OauthAdd = (props: OauthAddType): ReactElement => {
  const client = {
    id: '',
    name: '',
    status: '',
    clientId: '',
    createdDate: ''
  }
  const errorNameRef = useRef<HTMLParagraphElement>(null)  
  const errorUrlRef = useRef<HTMLParagraphElement>(null)
  const errorLoginRef = useRef<HTMLParagraphElement>(null)
  const [copiedInfo, setCopiedInfo] = useState(false)
  const [buttonCopy, setButtonCopy] = useState(<Translate id={'addOauthIntegration.initialButtonLabel'} />)
  const [integrationName, setIntegrationName] = useState('')
  const [loginUrl, setLoginUrl] = useState('')
  const [buttonDisabled, setButtonDisabled] = useState(true)
  const [redirectUrls, setRedirectUrls] = useState([''])
  const [clientId, setClientId] = useState('')
  const [sharedSecret, setSharedSecret] = useState('')
  const [oauthClientId, setOauthClientId] = useState('')
  const [friendlyNameInlineError, setFriendlyNameInlineError] = useState('common.form.validation.required')
  const [redirectUrlInlineError, setRedirectUrlInlineError] = useState('common.form.validation.required')
  const [loginUrlInlineError, setLoginUrlInlineError] = useState('common.form.validation.required')
  const [invalidRegex, setInvalidRegex] = useState(false)
  const [invalidUrlRegex, setInvalidUrlRegex] = useState(false)
  const [ref, setRef] = useState(errorUrlRef.current)
  const [val, setVal] = useState('')
  const [refUrl, setRefUrl] = useState(errorLoginRef.current)
  const [urlVal, setUrlVal] = useState('')
  const [clients, setClients] = useState([client])
  const [inlineErrorUrl, setInlineErrorUrl] = useState(false)
  const [inlineErrorName, setInlineErrorName] = useState(false)
  const [inlineErrorLoginUrl, setInlineErrorLoginUrl] = useState(false)
  const [accessTokenTtl, setAccessTokenTtl] = useState(60)
  const [refreshTokenTtl, setRefreshTokenTtl] = useState(120)
  const [accessTokenPositiveNumberError, setAccessTokenPositiveNumberError] = useState(false)
  const [refreshTokenPositiveNumberError, setRefreshTokenPositiveNumberError] = useState(false)
  const [accessTokenMissingError, setAccessTokenMissingError] = useState(false)
  const [refreshTokenMissingError, setRefreshTokenMissingError] = useState(false)
  const [appCodePrefix, setAppCodePrefix] = useState('')

  useEffect(() => {
    props.addOauthClient().then((response: any) => {
      response.map(item => {
        setClientId(item.client_id)
        setSharedSecret(item.client_secret)
        setOauthClientId(item.id)
      })
    })
    props.fetchAllOauthClients(props.match ? props.match.params.id : undefined).then((response: any) => {
      setClients(response[0])
    })
  }, [props])

  function handleIntegrationName (event: React.ChangeEvent<HTMLInputElement>): void {
    setIntegrationName(event.target.value)
    const ref = errorNameRef.current
    if (ref) {
      ref.style.display = 'none'
      setInlineErrorName(false)
      if (event.target.value === '') {
        ref.style.display = 'block'
        setFriendlyNameInlineError('common.form.validation.required')
        setInlineErrorName(true)
      }
      if (event.target.value.length > 256) {
        setFriendlyNameInlineError('addOauthIntegration.friendlyNameLengthValidation')
        ref.style.display = 'block'
        setInlineErrorName(true)
      }
      if (clients.find(client => client.name.trim().toLowerCase() === event.target.value.trim().toLowerCase()) !== undefined) {
        setFriendlyNameInlineError('addOauthIntegration.friendlyNameUnique')
        ref.style.display = 'block'
        setInlineErrorName(true)
      }
    }
  }

  function handleLoginUrl (event: React.ChangeEvent<HTMLInputElement>): void {
    setLoginUrl(event.target.value)
    const ref = errorLoginRef.current
    if (ref) {
      setRefUrl(ref)
      setUrlVal(event.target.value)
      ref.style.display = 'none'
      setInlineErrorLoginUrl(false)
      try {
        const regexObj = new RegExp(event.target.value, '');
        setInvalidUrlRegex(false)
      } catch(e) {
        setInvalidUrlRegex(true)
      }
      if (event.target.value === '') {
        ref.style.display = 'block'
        setLoginUrlInlineError('common.form.validation.required')
        setInlineErrorLoginUrl(true)
      }
      if (event.target.value.length > 2048) {
        setLoginUrlInlineError('addOauthIntegration.redirectUrlLengthValidation')
        ref.style.display = 'block'
        setInlineErrorLoginUrl(true)
      }
    }
  }

  const accessTokenTtlValidity = useCallback(() => {
    if (accessTokenPositiveNumberError) {
      return translate('dashboardLicense.validation.positiveNumber') as string
    }
    else if (accessTokenMissingError) {
      return translate('notifications.errors.valueMissingError') as string
    }
    else if (accessTokenTtl < 5) {
      return translate('addOauthIntegration.accessTokenLowerLimit') as string
    }
    else if (accessTokenTtl > 1440) {
      return translate('addOauthIntegration.accessTokenUpperLimit') as string
    }
  },[accessTokenTtl, accessTokenPositiveNumberError, accessTokenMissingError])

  const handleAccessTokenTtl = useCallback((event) => {
    const input = event.target.value
    if (
      !/^\d*$/.test(input) ||
      /^0[0-9].*$/.test(input) ||
      /^\d*\.\d*$/.test(input) ||
      /^([a-zA-Z])\w+/.test(input)
    ) {
      setAccessTokenPositiveNumberError(true)
    } else if(input === '') {
      setAccessTokenMissingError(true)
    }
    else {
      setAccessTokenPositiveNumberError(false)
      setAccessTokenMissingError(false)
      setAccessTokenTtl(Number(input))
    }
  },[setAccessTokenTtl])

  const refreshTokenTtlValidity = useCallback(() => {
    if (refreshTokenPositiveNumberError) {
      return translate('dashboardLicense.validation.positiveNumber') as string
    }
    else if (refreshTokenMissingError) {
      return translate('notifications.errors.valueMissingError') as string
    }
    else if (refreshTokenTtl < 5) {
      return translate('addOauthIntegration.refreshTokenLowerLimit') as string
    }
    else if (refreshTokenTtl > 2880) {
      return translate('addOauthIntegration.refreshTokenUpperLimit') as string
    }
  },[refreshTokenTtl, refreshTokenPositiveNumberError, refreshTokenMissingError])

  const handleRefreshTokenTtl = useCallback((event) => {
    const input = event.target.value
    if (
      !/^\d*$/.test(input) ||
      /^0[0-9].*$/.test(input) ||
      /^\d*\.\d*$/.test(input) ||
      /^([a-zA-Z])\w+/.test(input)
    ) {
      setRefreshTokenPositiveNumberError(true)
    } else if(input === '') {
      setRefreshTokenMissingError(true)
    } else {
      setRefreshTokenPositiveNumberError(false)
      setRefreshTokenMissingError(false)
      setRefreshTokenTtl(Number(input))
    }
  },[setRefreshTokenTtl])

  function addRedirectUrl (): void {
    setRedirectUrls(redirectUrls.concat(''))
  }

  function deleteRedirectUrl (url: string): void {
    const tmpUrls = redirectUrls.filter(item => item !== url)
    setRedirectUrls(tmpUrls)
    const ref = errorUrlRef.current
    if (ref) {
      tmpUrls.length === 0 ? ref.style.display = 'block' : ref.style.display = 'none'
    }
  }

  function handleIntegrationRedirectUrl (index: number, event: React.ChangeEvent<HTMLInputElement>): void {
    const tmpUrls = [...redirectUrls]
    tmpUrls[index] = event.target.value
    setRedirectUrls(tmpUrls)
    const ref = errorUrlRef.current
    const val = event.target.value
    if (ref) {
      setRef(ref)
      setVal(val)
      setRedirectUrlInlineError('common.form.validation.required')
      ref.style.display = 'none'
      setInlineErrorUrl(false)
      try {
        // const regexObj = new RegExp(event.target.value, '');
        setInvalidRegex(false)
      } catch(e) {
        setInvalidRegex(true)
      }
      if (event.target.value.length > 2048) {
        setRedirectUrlInlineError('addOauthIntegration.redirectUrlLengthValidation')
        ref.style.display = 'block'
        setInlineErrorUrl(true)
      }
      if (event.target.value === '') {
        ref.style.display = 'block'
        setRedirectUrlInlineError('common.form.validation.required')
        setInlineErrorUrl(true)
      }
    }
  }

  function addIntegration (e) {
    e.preventDefault()
    const payload = {
      'account_id': props.match ? props.match.params.id : undefined,
      id: clientId,
      name: integrationName,
      'oauth_config': {
        'redirect_uris': redirectUrls,
        'login_url': loginUrl,
        'access_token_ttl': accessTokenTtl * 60 ,
        'refresh_token_ttl':refreshTokenTtl * 60
      },
      enabled: true,
      'app_code_prefix': appCodePrefix
    }
    props.addIntegration(payload, oauthClientId).then((response: any) => {
      if (response) {
        setIntegrationName('')
        setRedirectUrls([])
        setButtonDisabled(true)
        setCopiedInfo(false)
      }
    })
    const selection = document.getSelection()
    if (selection) {
      selection.removeAllRanges()
    }
    setTimeout(function (){
      history.goBack()
    }, 1000)
  }

  function cancelIntegration (e): void {
    e.preventDefault()
    history.goBack()
  }

  function handleIsCopied (copied: boolean): void {
    if (copied) {
      setCopiedInfo(true)
      setButtonCopy(<Translate id={'addOauthIntegration.buttonLabel'} />)
    }
  }

  const handleAppCode = (e): void => {
    setAppCodePrefix(e.target.value)
  }

  useEffect(() => {
    if(ref && val !== '') {
      if (invalidRegex) {
        setRedirectUrlInlineError('addOauthIntegration.redirectUrlRegexValidation')
        ref.style.display = 'block'
        setInlineErrorUrl(true)
      } else if (!urlRegExpression.test(val) && reg.test(val)) {
        setRedirectUrlInlineError('addOauthIntegration.invalidUrl')
        ref.style.display = 'block'
        setInlineErrorUrl(true)
      }
    }
    if(refUrl && urlVal !== '') {
      if (invalidUrlRegex) {
        setLoginUrlInlineError('addOauthIntegration.redirectUrlRegexValidation')
        refUrl.style.display = 'block'
        setInlineErrorLoginUrl(true)
      } else if (!urlRegExpression.test(urlVal) && reg.test(urlVal)) {
        setLoginUrlInlineError('addOauthIntegration.invalidUrl')
        refUrl.style.display = 'block'
        setInlineErrorLoginUrl(true)
      }
    }
    if (!inlineErrorLoginUrl && !inlineErrorUrl && !inlineErrorName && copiedInfo && redirectUrls.length !== 0 && redirectUrls.every(elem => elem !== '')) {
      setButtonDisabled(false)
    } else {
      setButtonDisabled(true)
    }
  }, [integrationName, copiedInfo, redirectUrls, invalidRegex, ref, reg, val, refUrl, urlVal, inlineErrorUrl, inlineErrorName, inlineErrorLoginUrl])

  return (
    <section className={styles.oAuthAdd}>
      <header className={styles.oAuthAddHeader}>
        <h1><Translate id={'addOauthIntegration.headline'}/></h1>
      </header>

      <Form center={false} onSubmit={(e) => { addIntegration(e) }}>
        <div className={styles.oAuthInputSection}>
          <h4><Translate id={'addOauthIntegration.inputNameLabel'} /></h4>
          <p><Translate id={'addOauthIntegration.inputNameDescription'} /></p>
          <input className={styles.oAuthInput} type='text' value={integrationName} onChange={handleIntegrationName} />
          <p className={styles.oAuthInputErrorMessage} ref={errorNameRef}><Translate id={friendlyNameInlineError} /></p>
        </div>
        <div className={styles.oAuthInputSection}>
          <Input
            label={translate('addOauthIntegration.applicationCodePrefix') as string}
            size={FormFieldSize.S}
            required
            errors={{valueMissing: translate('notifications.errors.valueMissingError') as string}}
            defaultValue={appCodePrefix}
            onChange={handleAppCode}
          />
        </div>

        <hr />
        <h3><Translate id={'addOauthIntegration.settingsHeadline'} /></h3>

        <div className={styles.oAuthInputSection}>
          <h4><Translate id={'addOauthIntegration.inputRedirectLabel'} /></h4>
          <p><Translate id={'addOauthIntegration.inputRedirectDescription'} /></p>

          {redirectUrls.map((item, index) => {
            return (
              <div className={styles.oAuthRedirectInputContainer} key={index}>
                <input className={styles.oAuthInputWithOption} type='text' value={item} onChange={(event):void => { handleIntegrationRedirectUrl(index, event) } } />
                <div className={styles.deleteRedirect}>
                  <FontAwesomeIcon size='lg' icon={faTrashAlt as IconProp} onClick={():void => { deleteRedirectUrl(item) } }/>
                </div>
              </div>
            )
          })}
          <p className={styles.oAuthInputErrorMessage} ref={errorUrlRef}><Translate id={redirectUrlInlineError} /></p>
          <div className={styles.oAuthAddRedirectOption} onClick={addRedirectUrl}>
            <FontAwesomeIcon size='lg' icon={faPlusCircle as IconProp} /><Translate id={'oauthIntegration.addRedirectUrls'} />
          </div>
        </div>
        <div className={styles.oAuthInputSection}>
          <h4>{translate('addOauthIntegration.inputLoginUri') as string}</h4>
          <p>{translate('addOauthIntegration.inputLoginUriDescription') as string}</p>
          <input className={styles.oAuthInput} type='text' value={loginUrl} onChange={handleLoginUrl} />
          <p className={styles.oAuthInputErrorMessage} ref={errorLoginRef}><Translate id={loginUrlInlineError} /></p>
        </div>
        <div className={styles.oAuthInputSection}>
          <Input
            label={translate('addOauthIntegration.accessTokenTtl') as string}
            size={FormFieldSize.S}
            required
            errors={{valueMissing: translate('notifications.errors.valueMissingError') as string}}
            defaultValue={60}
            onChange={handleAccessTokenTtl}
            validate={accessTokenTtlValidity}
          />
        </div>
        <div className={styles.oAuthInputSection}>
          <Input
            label={translate('addOauthIntegration.refreshTokenTtl') as string}
            size={FormFieldSize.S}
            required
            errors={{valueMissing: translate('notifications.errors.valueMissingError') as string}}
            defaultValue={120}
            onChange={handleRefreshTokenTtl}
            validate={refreshTokenTtlValidity}
          />
        </div>

        <MultiCopy
          primaryOption={clientId}
          primaryOptionLabel={translate('addOauthIntegration.clientIdLabel') as string}
          secondaryOption={sharedSecret}
          secondaryOptionLabel={translate('addOauthIntegration.sharedSecretIdLabel') as string}
          tooltipMessage={translate('addOauthIntegration.clipBoardTooltipMessage') as string}
          tooltipSuccessMessage={translate('addOauthIntegration.clipBoardTooltipSuccessMessage') as string}
          supportWarning={translate('addOauthIntegration.writeTextSupportWarning') as string}
          callback={handleIsCopied}
        />

        <div className={styles.oAuthActions}>
          <Button
            buttonType={ButtonType.SECONDARY}
            onClick={(e) => cancelIntegration(e)}>
            <Translate id={'addOauthIntegration.cancelButtonLabel'} />
          </Button>

          <SubmitButton
            disabled={buttonDisabled}>
            {buttonCopy}
          </SubmitButton>
        </div>
      </Form>
    </section>
  )
}

export default connect(
  () => {
  },
  { addOauthClient, addIntegration, fetchAllOauthClients }
)(OauthAdd)
